<dt class="key-val-item" [ngClass]="{'error': error}">
	<ng-content select="[kv-key]"></ng-content>
	<cm-inline-alert *ngIf="alert" [type]="type">{{ alert }}</cm-inline-alert>
	<button *ngIf="downloadUrl" cm-link-button [cmFileDownload]="downloadUrl" [targetWindow]='downloadTargetWindow'>
		<ats-icon name="download" [size]="12" class="mr-4"></ats-icon>
		<span [cmLocalize]="locFeature + '/System.Global.Content.Download'">
			Download
		</span>
	</button>
</dt>
<dd>
	<ng-container *ngIf="isBool; else noBool">
		<span *ngIf="boolean">
			<ats-icon name="circle-check" [title]="'Yes' | cmLocalize: locFeature + '/System.Global.Content.True'">
			</ats-icon>
		</span>
		<span *ngIf="!boolean">
			<ats-icon name="circle" [title]="'No' | cmLocalize: locFeature + '/System.Global.Content.False'">
			</ats-icon>
		</span>
	</ng-container>
	<ng-template #noBool>
		<ng-content></ng-content>
	</ng-template>
</dd>
